import { Container } from 'react-bootstrap';

import { Post } from 'apps/shared/scripts/__generated__/graphql.generated';

import CardPost from '../CardPost';

import CardPostsLayout from './CardPostsLayout';
import CardPostsLayoutItem from './CardPostsLayoutItem';
import { cardPostsClassName } from './styles';

interface Props {
  isCardDelivered?: boolean;
  isCardOwner?: boolean;
  posts: Post[];
}

const CardPosts = ({ posts, isCardOwner, isCardDelivered }: Props) => {
  const list = posts.map((m: Post) => {
    return (
      <CardPostsLayoutItem key={m.id}>
        <CardPost
          {...m}
          isCardOwner={isCardOwner}
          isCardDelivered={isCardDelivered}
        />
      </CardPostsLayoutItem>
    );
  });

  if (!posts.length) {
    // @todo(jgan): empty state
  }

  return (
    <div className={cardPostsClassName}>
      <Container className="container-flex">
        <CardPostsLayout>{list}</CardPostsLayout>
      </Container>
    </div>
  );
};

CardPosts.displayName = 'CardPosts';

export default CardPosts;
